import { post, get } from "../util/crmAxios";
import { getBasicUrls } from "../util/config";
const schoolm = getBasicUrls().schoolm;

// 获取账户变动通知列表
export const getList = (params) =>
  post(schoolm + "manage/accountChangeNotice/getList", params);

// 阅读账户变动通知
export const read = (params) =>
  post(schoolm + "manage/accountChangeNotice/read", params);

// 查询账户资产看板
export const queryAgentAccountBand = (params) =>
  get(schoolm + "manage/agent/queryAgentAccountBand", params);

// 查询账户结算单
export const querySettlementOrderByPage = (params) =>
  post(schoolm + "manage/agent/recharge/querySettlementOrderByPage", params);

// 获取支出/转移方式
export const queryExpendMethodList = (params) =>
  post(schoolm + "manage/config/queryExpendMethodList", params);

// 获取账户项目类型信息
export const queryAccountItemList = (params) =>
  post(schoolm + "manage/config/queryAccountItemList", params);

// 代理商账户---退款记录金额统计
export const queryAgentAccountRefundAmount = (params) =>
  post(schoolm + "manage/agent/refund/queryAgentAccountRefundAmount", params);

// 代理商账户---退款记录接口
export const queryAgentAccountRefundPage = (params) =>
  post(schoolm + "manage/agent/refund/queryAgentAccountRefundPage", params);


// 代理商账户---消费记录接口
export const queryOrderSerialByPage = (params) =>
  post(schoolm + "/manage/purchase/order/queryOrderSerialByPage", params);

// 电子账户---充值记录接口
export const queryRecordListByPage = (params) =>
  post(schoolm + "/manage/agent/recharge/queryRecordListByPage", params);

// 电子账户---充值记录接口
export const queryAgentRegionFeePage = (params) =>
  post(schoolm + "/manage/purchase/order/queryAgentRegionFeePage", params);

// 电子账户---转现金账户记录接口
export const queryWithdrawalTransferByPage = (params) =>
  post(
    schoolm + "/manage/purchase/order/queryWithdrawalTransferByPage",
    params
  );
// 电子账户---转现金金额统计
export const queryWithdrawalTransferAmount = (params) =>
  post(
    schoolm + "/manage/purchase/order/queryWithdrawalTransferAmount",
    params
  );
// 电子账户---充值记录接口
export const queryWithdrawalSerialByPage = (params) =>
  post(schoolm + "/manage/purchase/order/queryWithdrawalSerialByPage", params);
// 电子账户---金额统计
export const queryWithdrawalSerialAmount = (params) =>
  post(schoolm + "/manage/purchase/order/queryWithdrawalSerialAmount", params);
// 金账户付款的订单明细-消费记录
export const queryGoldAgentPurchase = (params) =>
  post(schoolm + "/manage/purchase/order/queryGoldAgentPurchase", params);

// 代理商账户---余额接口
export const queryAgentAccount = (params) =>
  get(schoolm + "/manage/agent/queryAgentAccount", params);

// 电子账户---充值时获取充值状态接口getSchoolOrderStatus
export const getSchoolOrderStatus = (orderNo) =>
  get("/erp/school/getSchoolOrderStatus", orderNo);

//电子账户 --开票基本信息
export const getChargeEinvoceBaseInfo = (orderNo) =>
  get("/invoice/getChargeEinvoceBaseInfo", orderNo);

//电子账户 --发票开票
export const createChargeInvoice = (params) =>
  post("/invoice/createChargeInvoice", params);

//电子发票--开票记录列表
export const getChargeInvoiceList = (params) =>
  post("/invoice/getChargeInvoiceList", params);

//电子账户 ---发票详情
export const getChargeInvoiceDetail = (orderNo) =>
  get("/invoice/getChargeInvoiceDetail", orderNo);

//电子账户 --- 作废发票
export const einvoiceRedFlush = (params) =>
  post("/invoice/einvoiceRedFlush", params);

//电子账户 --- 获取时间判断是否禁止开票
export const getAppConfig = (orderNo) =>
  get("/base/sysconfig/getAppConfig", orderNo);

//收款流水
export const getCollectWater = (params) =>
  post(schoolm + "manage/agent/recharge/queryAgentAccountRechargeList", params);
//支付流水
export const queryAgentConsumeListByPage = (params) =>
  post(schoolm + "manage/agent/recharge/queryAgentConsumeListByPage", params);
// 支付流水总金额
export const queryAgentConsumeSumAmount = (params) =>
  post(schoolm + "manage/agent/recharge/queryAgentConsumeSumAmount", params);

//更新订单状 态
export const updateRechargeStatus = (params) =>
  post(schoolm + "manage/agent/recharge/updateRechargeStatus", params);

//充值记录确认汇 总
export const queryAgentAccountRechargeSum = (params) =>
  post(schoolm + "manage/agent/recharge/queryAgentAccountRechargeSum", params);
//订单选择页面的流水金额显示-绑定订 单
export const rechargeBindAmount = (params) =>
  post(schoolm + "manage/agent/recharge/rechargeBindAmount", params);
//流水绑定订单时查询订单列 表
export const queryOrdersByBind = (params) =>
  post(schoolm + "manage/purchase/order/queryOrdersByBind", params);
//充值流水绑定订 单
export const rechargeBindOrder = (params) =>
  post(schoolm + "manage/agent/recharge/rechargeBindOrder", params);
//订单绑定流水时，查询未绑定的流水列 表
export const queryUnBindRechargeList = (params) =>
  post(schoolm + "manage/agent/recharge/queryUnBindRechargeList", params);
//获取订单的分单信息
export const getPurchaseOrderSplit = (params) =>
  get(schoolm + "manage/purchase/order/getPurchaseOrderSplit", params);
//订单业绩分单
export const splitOrder = (params) =>
  post(schoolm + "manage/purchase/order/splitOrder", params);
//业绩分单计算金额
export const calculateOrderSplit = (params) =>
  post(schoolm + "manage/purchase/order/calculateOrderSplit", params);
//根据城市获取城市代理费信息
export const getRegionFeeByCityId = (params) =>
  get(schoolm + "manage/purchase/order/getRegionFeeByCityId", params);
//保存市级代理申请
export const saveAgentRegionFee = (params) =>
  post(schoolm + "manage/purchase/order/saveAgentRegionFee", params);
//市级代理编辑
export const getAgentRegionFee = (params) =>
  get(schoolm + "manage/purchase/order/getAgentRegionFee", params);
//修改采购单地址
export const updateOrderInfo = (params) =>
  post(schoolm + "small/tool/updateOrderInfo", params);
//修改地址时-获取修改订单信息
export const getUpdateOrderInfo = (params) =>
  get(schoolm + "small/tool/getUpdateOrderInfo", params);
//获取代理商金账户区代信息
export const getAgentGoldRegionInfo = (params) =>
  post(schoolm + "manage/gold/getAgentGoldRegionInfo", params);
//修改地址时-获取修改订单信息
export const queryOrderInfo = (params) =>
  get(schoolm + "manage/purchaseInvoice/queryOrderInfo", params);
//保存发票
export const saveInvoice = (params) =>
  post(schoolm + "manage/purchaseInvoice/saveInvoice", params);
//查询订单已开发票
export const queryOrderInvoice = (params) =>
  get(schoolm + "manage/purchaseInvoice/queryOrderInvoice", params);
//获取天猫订单打印数据
export const wayBillGet = (params) =>
  post(schoolm + "manage/tmall/wayBillGet", params);
//获取天猫订单打印数据
export const queryWayBillCodeByPurchaseNo = (params) =>
  get(schoolm + "manage/tmall/queryWayBillCodeByPurchaseNo", params);
//获取提现账户金额信息
export const queryWithdrawalAccount = (params) =>
  get(schoolm + "manage/agent/queryWithdrawalAccount", params);
//获取提现账户金额信息
export const getAgentInvoiceInfo = (params) =>
  get(schoolm + "manage/agent/invoice/getAgentInvoiceInfo", params);
//获取提现账户金额-已确认信息
export const queryWithdrawalInvoiceInfo = (params) =>
  get(schoolm + "manage/agent/invoice/queryWithdrawalInvoiceInfo", params);
//提现账户申请提现
export const withdrawalApply = (params) =>
  post(schoolm + "manage/transfer/order/withdrawalApply", params);
//提现账户转现金账户
export const transferAccount = (params) =>
  post(schoolm + "manage/purchase/order/transferAccount", params);
//权益返还列表
export const queryRegionReturnList = (params) =>
  post(schoolm + "manage/transfer/order/queryRegionReturnList", params);
//权益返还列表
export const batchConfirmReturn = (params) =>
  post(schoolm + "manage/transfer/order/batchConfirmReturn", params);
//权益返还类型列表
export const queryRebatePayList = (params) =>
  post(schoolm + "manage/config/queryRebatePayList", params);
//获取当前通知信息
export const queryDeliveryStoreInfo = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryStoreInfo", params);
//豁免到期列表查询
export const queryDeliveryStorePage = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryStorePage", params);
//扣除仓储管理费
export const deductDeliveryStore = (params) =>
  post(schoolm + "manage/delivery/deductDeliveryStore", params);
//豁免到期代理商类型列表
export const queryAgentType = (params) =>
  get(schoolm + "manage/delivery/queryAgentType", params);
/**
 * 查询代理层级  =>
 * @param {*} params
 * @returns
 */
// 查询代理层级关系列表
export const queryAgentRelation = (params) =>
  post(schoolm + "manage/agent/relation/queryAgentRelation", params);
// 删除代理层级关系列表
export const removeRegionRelation = (params) =>
  post(schoolm + "manage/agent/relation/removeRegionRelation", params);
// 新增代理层级关系
export const addRegionAgentRelation = (params) =>
  post(schoolm + "manage/agent/relation/addRegionAgentRelation", params);
// 修改代理层级关系
export const modifyAgentRelation = (params) =>
  post(schoolm + "manage/agent/relation/modifyAgentRelation", params);
// 获取校区区域信息
export const getCampusAreaInfo = (params) =>
  get(schoolm + "manage/agent/relation/getCampusAreaInfo", params);
// 获取代理商标记
export const getRegionAgentMark = (params) =>
  get(schoolm + "manage/agent/relation/getRegionAgentMark", params);
// 获取代理商层级关系信息
export const getAgentRelationById = (params) =>
  get(schoolm + "manage/agent/relation/getAgentRelationById", params);
// ----------------------------------------------------------------
//代理商设备激活统计
export const queryLearningMachineActiveInfo = (params) =>
  post(
    schoolm + "manage/purchase/order/queryLearningMachineActiveInfo",
    params
  );
//代理商订单信息
export const queryAgentOrderInfo = (params) =>
  post(schoolm + "manage/purchase/order/queryAgentOrderInfo", params);
//获取 代理商 省市区接口
export const getCityTreeForRegionfee = (params) =>
  get(schoolm + "manage/purchase/order/getCityTreeForRegionfee", params);
//通过代理商id获取代理商类型
export const getAgentInfo = (params) =>
  get(schoolm + "manage/purchase/order/getAgentInfo", params);

// ----------------------------------------------------------------
//根据订单ID获取开票信息
export const getPurchaseInvoiceInfoByOrderId = (params) =>
  get(schoolm + "manage/agent/invoice/getPurchaseInvoiceInfoByOrderId", params);
//计算开票信息
export const calcInvoice = (params) =>
  post(schoolm + "manage/agent/invoice/calcInvoice", params);
//保存开票信息
export const savePurchaseInvoice = (params) =>
  post(schoolm + "manage/agent/invoice/savePurchaseInvoice", params);

//公告中心列表
export const queryNoticeCenterList = (params) =>
  post(schoolm + "notice/queryNoticeCenterList", params);
//附件列表
export const queryNoticeFileItems = (params) =>
  post(schoolm + "notice/queryNoticeFileItems", params);
//查看公告详情
export const queryNoticeDetailInfo = (params) =>
  post(schoolm + "notice/queryNoticeDetailInfo", params);
//异议提交
export const addNoticeObjection = (params) =>
  post(schoolm + "notice/addNoticeObjection", params);
//公告提示
export const queryCurrentNoticeTip = (params) =>
  post(schoolm + "notice/queryCurrentNoticeTip", params);
//获取标记双重订单的代理商信息
export const queryDualOrderAgentPage = (params) =>
  post(schoolm + "manage/dual/order/queryDualOrderAgentPage", params);
//获取提货券账户信息
export const queryDelivery = (params) =>
  post(schoolm + "manage/delivery/queryDelivery", params);
//获取代理商发放的提货券记录
export const queryDeliveryGrantPage = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryGrantPage", params);
//获取代理商核销的提货券记录
export const queryDeliveryCancelPage = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryCancelPage", params);
//获取代理商收到的提货券记录
export const queryDeliveryReceivePage = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryReceivePage", params);
//获取代理商消费的提货券记录
export const queryDeliveryConsumePage = (params) =>
  post(schoolm + "manage/delivery/queryDeliveryConsumePage", params);

//财务中心-代理商账户-双重订单账户余额-新建双重订单时先校验
export const checkActivateTime = (params) =>
get(schoolm + "manage/dual/order/checkActivateTime", params);

//七鱼工单列表查询
export const queryWorkSheetList = (params) =>
post(schoolm + "manage/qiyukf/queryWorkSheetList", params);
//七鱼工单详情查询
export const getWorkSheet = (params) =>
post(schoolm + "manage/qiyukf/getWorkSheet", params);
//七鱼修改工单已读
export const updateWorkSheetRead = (params) =>
post(schoolm + "manage/qiyukf/updateWorkSheetRead", params);
//获取工单未读数
export const queryWorkSheetUnReadCount = (params) =>
post(schoolm + "manage/qiyukf/queryWorkSheetUnReadCount", params);
// 财务中心-权益管理-样机指标查询-查询列表接口 pgetProductSubModelByModelIdrototype/queryPrototypePage POST
export const queryPrototypePage = (params) =>
  post(schoolm + "prototype/queryPrototypePage", params);

// 验证是否需要修改商品配比
export const queryCompanyInfo = (params) => post(schoolm + "manage/config/queryCompanyInfo", params);

// 权益管理-分页查询
export const queryCampusRightBaseList = (params) =>
  post(schoolm + "right/base/queryCampusRightBaseList", params);

// 权益管理-分页查询
export const queryCampusRightByEntityUser = (params) =>
  get(schoolm + "right/base/queryCampusRightByEntityUser", params);

// -----云仓管理-仓内提货-新建提货单---------
//云仓管理-仓内提货-新建提货单
export const addLading = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/lading/addLading",
    params
  );
  
  //云仓管理-仓内提货-分页查询提货单列表
  export const queryLadingList = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/lading/queryLadingList",
    params
  );
  
  //云仓管理-仓内提货-导出
  export const exportLadingData = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/lading/exportLadingData",
    params
  );
  
  //云仓管理-仓内提货-取消提货
  export const cancelLading = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/lading/cancelLading",
    params
  );
  
  //云仓管理-仓内提货-取消调拨
  export const cancelTransferOrder = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/transfer/cancelTransferOrder",
    params
  );
  
  //云仓管理-仓内提货-查询提货单详情
  export const queryLading = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/lading/queryLading",
    params
  );
  
  //云仓管理-仓内提货-查询调拨单详情
  export const queryTransferOrder = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/transfer/queryTransferOrder",
    params
  );
  
  
  //云仓管理-仓内提货-分页查询调拨单列表
  export const queryTransferOrderList = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/transfer/queryTransferOrderList",
    params
  );

  //云仓管理-获取代理商关联仓库
export const queryCampusWarehouse = params =>
  post(
    getBasicUrls().schoolm + "manage/warehouse/inventory/queryCampusWarehouse",
    params
  );

  // 查询发货状态列表
export const querySoStatus = params =>
  get(getBasicUrls().schoolm + "manage/goodsdeliver/querySoStatus", params);

// 获取代理商仓库列表
export const queryAgentWarehouseList = params =>
  get(
    getBasicUrls().schoolm + "manage/purchase/order/queryAgentWarehouseList",
    params
  );

//获取代理商信息
export const querySchoolAgentByCampusId = params =>
  get(
    getBasicUrls().schoolm + "manage/purchase/order/querySchoolAgentByCampusId",
    params
  );

// 入库仓库列表
export const getWarehouseList = params =>
  get(getBasicUrls().schoolm + "manage/stock/getWarehouseList", params);